import { Share2 } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const Share2Icon = createLucideIcon(Share2);
